<template>
  <div>
    <v-flex>
      <v-snackbar
        v-model="dialog.snackbar"
        top
        right
        color="#ff64ad">
        <span class="body-1 font-weight-light white--text"
          v-html="message.success">
        </span>

        <template v-slot:action="{ attrs }">
          <v-btn
            class="body-1 font-weight-bold text-capitalize"
            color="white"
            icon
            v-bind="attrs"
            @click="dialog.snackbar = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <section>
        <div @click="$router.push('/service?menu=bpp')"
          class="d-flex align-center color-first cursor-pointer mb-2">
          <v-icon color="#ff64ad">mdi-arrow-left-thick</v-icon>
      
          <span class="body-1 ml-1">
            Kembali
          </span>
        </div>

        <ValidationObserver 
          ref="form">
          <v-form 
            class="text-left">
            <v-row>
              <v-col 
                cols="12" 
                md="7">
                <v-card 
                  flat>
                  <v-card-text 
                    class="pa-0">
                    <ValidationProvider 
                      name="nik" 
                      rules="required|min:16|max:16" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        NIK Jenazah
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                        outlined
                        dense
                        type="number"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        min="0"
                        placeholder="Contoh. 33100062XXXXXXX"
                        
                        :counter="16"

                        hide-details
                        
                        v-model="form.nik"
                        v-uppercase
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              NIK Jenazah {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.nik !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="nama" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Jenazah
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 90}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Murtoyo"
                        
                        hide-details

                        v-model="form.nama"
                        v-uppercase
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Jenazah {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.nama !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <div>
                      <div class="body-2 mb-2">
                        Tempat Lahir
                        <span>
                          (bisa dikosongi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Klaten"
                        
                        hide-details

                        v-model="form.tempat_lahir"
                        v-uppercase
                        :success="form.tempat_lahir !== ''"
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="form.tempat_lahir !== ''">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </div>

                    <div>
                      <div class="body-2 mb-2">
                        Tanggal Lahir 
                        <span>
                          (bisa dikosongi)
                        </span>
                      </div>

                      <v-menu
                        ref="birth"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.birth">
                        <template v-slot:activator="{ on }">
                          <div>
                            <v-text-field
                              v-on:keyup.enter="save"
                              :style="`width: ${rps === 'xs' ? 100 : 30}%`"
                              readonly
                              outlined
                              dense
                              color="#ff64ad"
                              placeholder="Contoh. 1978-02-03"

                              hide-details

                              v-model="form.tanggal_lahir"
                              v-uppercase
                              :success="form.tanggal_lahir !== '' && form.tanggal_lahir !== null"
                              clearable
                              @click:clear="form.tanggal_lahir = ''"
                              v-on="on"
                              class="mb-6">
                              <template v-slot:append-outer>
                                <div v-if="form.tanggal_lahir !== '' && form.tanggal_lahir !== null">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </div>
                        </template>
                        
                        <v-date-picker 
                          color="#ff64ad"
                          v-model="form.tanggal_lahir"
                          @input="picker.birth = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <ValidationProvider 
                      name="tempat_meninggal" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tempat Meninggal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Klaten"
                        
                        hide-details

                        v-model="form.tempat_meninggal"
                        v-uppercase
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tempat Meninggal {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.tempat_meninggal !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <div>
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal Meninggal
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-menu
                        ref="dead"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.dead">
                        <template v-slot:activator="{ on }">
                          <ValidationProvider 
                            name="tanggal_meninggal" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              :style="`width: ${rps === 'xs' ? 100 : 30}%`"
                              readonly
                              outlined
                              dense
                              color="#ff64ad"
                              placeholder="Contoh. 1978-02-03"
                              
                              hide-details

                              v-model="form.tanggal_meninggal"
                              v-uppercase
                              :success="valid"
                              :error-messages="errors"
                              required
                              clearable
                              @click:clear="form.tanggal_meninggal = ''"
                              v-on="on"
                              class="mb-6">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal Meninggal {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.tanggal_meninggal !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>
                        
                        <v-date-picker 
                          color="#ff64ad"
                          v-model="form.tanggal_meninggal"
                          @input="picker.dead = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <ValidationProvider 
                      name="alamat" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Dukuh / Dusun
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 90}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Kemiri"
                        
                        hide-details

                        v-model="form.alamat"
                        v-uppercase
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Dukuh / Dusun {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.alamat !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        <ValidationProvider 
                          name="rt" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            RT
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-text-field
                            v-on:keyup.enter="save"
                            outlined
                            type="number"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            min="0"
                            dense
                            color="#ff64ad"
                            placeholder="Contoh. 22"
                            
                            hide-details

                            v-model="form.rt"
                            v-uppercase
                            :success="valid"
                            :error-messages="errors"
                            required
                            class="mb-6">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  RT {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.rt !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>

                      <v-col
                        cols="3"
                        class="py-0">
                        <ValidationProvider 
                          name="rw" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            RW
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-text-field
                            v-on:keyup.enter="save"
                            outlined
                            type="number"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            min="0"
                            dense
                            color="#ff64ad"
                            placeholder="Contoh. 10"
                            
                            hide-details

                            v-model="form.rw"
                            v-uppercase
                            :success="valid"
                            :error-messages="errors"
                            required
                            class="mb-6">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  RW {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.rw !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>

                    <ValidationProvider 
                      name="kecamatan_name" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Kecamatan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        disabled
                        :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Trucuk"
                        
                        hide-details

                        v-model="form.kecamatan_name"
                        v-uppercase
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Kecamatan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.kecamatan_name !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="desa_name" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Kelurahan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        disabled
                        :style="`width: ${rps === 'xs' ? 100 : 70}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Kradenan"
                        
                        hide-details

                        v-model="form.desa_name"
                        v-uppercase
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-4">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Kelurahan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.desa_name !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col 
                cols="12" 
                md="5">
                <v-card 
                  flat>
                  <v-card-text 
                    class="pa-0">
                    <div
                      class="body-1 font-weight-bold black--text">
                      Tanggal / Tempat Pemakaman
                    </div>

                    <v-divider
                      class="mt-2 mb-4"
                      style="border-top: 5px solid #eaeaea; border-radius: 50px;" />
                    
                    <div>
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal Pemakaman
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-menu
                        ref="rip"
                        min-width="290px"
                        max-width="290px"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        :close-on-content-click="false"
                        v-model="picker.rip">
                        <template v-slot:activator="{ on }">
                          <ValidationProvider 
                            name="tanggal_pemakaman" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              :style="`width: ${rps === 'xs' ? 100 : 45}%`"
                              outlined
                              readonly
                              dense
                              color="#ff64ad"
                              placeholder="Contoh. 1978-02-03"
                              
                              hide-details

                              v-model="form.tanggal_pemakaman"
                              v-uppercase
                              :success="valid"
                              :error-messages="errors"
                              required
                              clearable
                              @click:clear="form.tanggal_pemakaman = ''"
                              v-on="on"
                              class="mb-6">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    Tanggal Pemakaman {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.tanggal_pemakaman !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </template>
                        
                        <v-date-picker 
                          color="#ff64ad"
                          v-model="form.tanggal_pemakaman"
                          @input="picker.rip = false">
                        </v-date-picker>
                      </v-menu>
                    </div>

                    <ValidationProvider 
                      name="makam_kecamatan_code" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Kecamatan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-autocomplete
                        :style="`width: ${rps === 'xs' ? 100 : 100}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Trucuk"
                        
                        hide-details

                        :search-input.sync="autocomplete.subdistrict"
                        :loading="process.subdistrict"
                        
                        :items="config.subdistrict"
                        item-value="kecamatan_code"
                        item-text="kecamatan_name"
                        item-color="#ff64ad"

                        v-model="form.makam_kecamatan_code"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Kecamatan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.makam_kecamatan_code !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="makam_desa_code" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Kelurahan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-autocomplete
                        :style="`width: ${rps === 'xs' ? 100 : 100}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Kradenan"
                        
                        hide-details

                        :search-input.sync="autocomplete.village"
                        :loading="process.village"
                        
                        :items="config.village"
                        item-value="desa_code"
                        item-text="desa_name"
                        item-color="#ff64ad"

                        v-model="form.makam_desa_code"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Kelurahan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.makam_desa_code !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="makam_kode" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Tempat Pemakaman
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-autocomplete
                        :style="`width: ${rps === 'xs' ? 100 : 100}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Kradenan"
                        
                        hide-details

                        :search-input.sync="autocomplete.makam"
                        :loading="process.makam"
                        
                        :items="config.makam"
                        item-value="bpptp_id"
                        item-text="bpptp_nama"
                        item-color="#ff64ad"

                        v-model="form.makam_kode"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Tempat Pemakaman {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.makam_kode !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>

                    <div
                      class="body-1 font-weight-bold black--text">
                      Penanggung Jawab
                    </div>

                    <v-divider
                      class="mt-2 mb-4"
                      style="border-top: 5px solid #eaeaea; border-radius: 50px;" />

                    <ValidationProvider 
                      name="keluarga_telp_nama" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Keluarga
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 100}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Contoh. Murtoyo"
                        
                        hide-details

                        v-model="form.keluarga_telp_nama"
                        v-uppercase
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Keluarga {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.keluarga_telp_nama !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <ValidationProvider 
                      name="keluarga_telp_no" 
                      rules="min:8|max:13"
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        Nomor Telepon Keluarga
                        <span>
                          (bisa dikosongi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 50}%`"
                        outlined
                        dense
                        color="#ff64ad"
                        type="number"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        min="0"
                        placeholder="Contoh. 081322XXXXXX"
                        
                        hide-details

                        v-model="form.keluarga_telp_no"
                        v-uppercase
                        :success="form.keluarga_telp_no !== '' && valid"
                        :error-messages="errors"
                        required
                        class="mb-6">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nomor Telepon Keluarga {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.keluarga_telp_no !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <div>
                      <div class="body-2 mb-2">
                        Keterangan
                        <span>
                          (bisa dikosongi)
                        </span>
                      </div>

                      <v-textarea
                        v-on:keyup.enter="save"
                        :style="`width: ${rps === 'xs' ? 100 : 100}%`"
                        outlined
                        dense
                        rows="3"
                        color="#ff64ad"
                        placeholder="Contoh. Perubahan nama dan foto"
                        
                        hide-details

                        v-model="form.note"
                        v-uppercase
                        :success="form.note !== ''"
                        class="mb-4">
                        <template v-slot:append-outer>
                          <div v-if="form.note !== ''">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-textarea>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>

        <div>
          <v-divider class="mb-4" style="border: 3px solid #eaeaea; border-radius: 50px;"/>

          <v-alert 
            type="error" 
            text dense prominent 
            class="mt-6"
            v-show="message.error.length > 0">
            {{  message.error }}
          </v-alert>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              :disabled="process.form"
              :loading="process.form"
              v-on:keyup.enter="save()"
              @click="save()">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="$router.push('/service?menu=bpp')">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </div>
      </section>
    </v-flex>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        config: {
          // ADDRESS
          subdistrict: [],
          village: [],

          // MAKAM
          makam: [],
          jenis_makam: []
        },

        detail: {},

        picker: {
          birth: false,
          dead: false,
          rip: false
        },

        autocomplete: {
          // ADDRESS
          subdistrict: '',
          village: '',
          
          // MAKAM
          makam: ''
        },

        form: {
          id: '',
          nik: '',
          nama: '',
          tempat_lahir: '',
          tanggal_lahir: '',
          tempat_meninggal: '',
          tanggal_meninggal: '',
          alamat: '',
          rt: '',
          rw: '',
          kecamatan_code: '',
          kecamatan_name: '',
          desa_code: '',
          desa_name: '',
          tanggal_pemakaman: '',
          makam_kecamatan_code: '',
          makam_kecamatan_name: '',
          makam_desa_code: '',
          makam_desa_name: '',
          makam_nama: '',
          makam_kode: '',
          keluarga_telp_nama: '',
          keluarga_telp_no: '',
          note: ''
        },

        process: {
          load: false,

          form: false,

          // ADDRESS
          subdistrict: false,
          village: false,

          // MAKAM
          makam: false,
          jenis_makam: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.makam_kecamatan_code': function() {
        let t = this
        let kec = this.config.subdistrict.filter(function(v) {
          return t.form.makam_kecamatan_code == v.kecamatan_code
        })

        if (kec.length > 0) {
          this.form.makam_kecamatan_name = kec[0].kecamatan_name

          this.form.makam_desa_code = ''
          this.form.makam_desa_name = ''
        }

        this.static().village()
      },

      'form.makam_desa_code': function() {
        let t = this
        let kel = this.config.village.filter(function(v) {
          return t.form.makam_desa_code == v.desa_code
        })

        if (kel.length > 0) {
          this.form.makam_desa_name = kel[0].desa_name
        }
      },

      'form.makam_kode': function() {
        let t = this
        let mak = this.config.makam.filter(function(v) {
          return t.form.makam_kode == v.bpptp_id
        })

        if (mak.length > 0) {
          this.form.makam_nama = mak[0].bpptp_nama
        }
      },

      'autocomplete.subdistrict': function() {
        this.static().subdistrict()
      },

      'autocomplete.village': function() {
        this.static().village()
        
        this.static().makam()
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`bpp/detail`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.load = false

            this.reset(res.data)
          }
        })
      },

      static () {
        let t = this
        return {
          async subdistrict () {
            t.process.subdistrict = true

            let params = {
              search: t.autocomplete.subdistrict,
              sort: 'DESC'
            }

            await get('location/kecamatan', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.subdistrict = false

                t.config.subdistrict = res.data
              }
            })
          },
          async village () {
            t.process.village = true

            let params = {
              desa_kecamatan_code: t.form.makam_kecamatan_code,
              search: t.autocomplete.village,
              sort: 'DESC'
            }

            await get('location/desa', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.village = false

                t.config.village = res.data
              }
            })
          },
          async makam () {
            t.process.makam = true

            let params = {
              search: t.autocomplete.makam,
              sort: 'DESC',
              limit: 10000,
              bpptp_desa_code: t.form.makam_desa_code
            }

            await get('tempat-pemakaman', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.makam = false

                t.config.makam = res.data
              }
            })
          },
          async jenis_makam () {
            t.process.jenis_makam = true

            let params = {
              sort: 'DESC',
              limit: 10000
            }

            await get('tempat-pemakaman/jenis', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.jenis_makam = false

                t.config.jenis_makam = res.data
              }
            })
          }
        }
      },

      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.bpp_id : '',
          nik: item !== undefined ? item.bpp_nik : '',
          nama: item !== undefined ? item.bpp_nama : '',
          tempat_lahir: item !== undefined ? item.bpp_tempat_lahir : '',
          tanggal_lahir: item !== undefined ? item.bpp_tanggal_lahir : '',
          tempat_meninggal: item !== undefined ? item.bpp_tempat_meninggal : '',
          tanggal_meninggal: item !== undefined ? item.bpp_tanggal_meninggal : '',
          alamat: item !== undefined ? item.bpp_alamat : '',
          rt: item !== undefined ? item.bpp_rt : '',
          rw: item !== undefined ? item.bpp_rw : '',
          kecamatan_code: item !== undefined ? item.bpp_kecamatan_code : '',
          kecamatan_name: item !== undefined ? item.bpp_kecamatan_name : '',
          desa_code: item !== undefined ? item.bpp_desa_code : '',
          desa_name: item !== undefined ? item.bpp_desa_name : '',
          tanggal_pemakaman: item !== undefined ? item.bpp_tanggal_pemakaman : '',
          makam_kecamatan_code: item !== undefined ? item.bpp_makam_kecamatan_code : '',
          makam_kecamatan_name: item !== undefined ? item.bpp_makam_kecamatan_name : '',
          makam_desa_code: item !== undefined ? item.bpp_makam_desa_code : '',
          makam_desa_name: item !== undefined ? item.bpp_makam_desa_name : '',
          makam_nama: item !== undefined ? item.bpp_makam_nama : '',
          makam_kode: item !== undefined ? Number(item.bpp_makam_kode) : '',
          keluarga_telp_nama: item !== undefined ? item.bpp_keluarga_telp_nama : '',
          keluarga_telp_no: item !== undefined ? item.bpp_keluarga_telp_no : '',
          note: item !== undefined ? item.bpp_note : ''
        }

        this.picker = {
          birth: false,
          dead: false,
          rip: false
        }

        this.process.form = false

        this.message.error = ''
      },

      async save() {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`bpp/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            if (res.code === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.$router.push('/service?menu=bpp')
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
    }
  }
</script>